export default {
    inserted: function (el) {
        el.addEventListener("click", function(e){
            e.preventDefault();
            el.select();
        });
    }
}
